import dayjs from "dayjs";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckoutStartDateInputContainer, } from "@containers/student/CheckoutStartDateInput";
import { Button } from "@components/student/Button";
import { Link } from "@components/ui/Link";
import { paymentDataToFormInputs } from "@utils/common";
import { getLessonDeclension } from "@utils/wordDeclension";
import * as s from "./CheckoutSummary.sss";
import { Checkbox } from "@/IndexLanding/components/Checkbox";
import useStudentCheckoutData from "@/local-state/hooks/useStudentCheckoutData";
import { publicContracts } from "@/urls";
export const CheckoutSummary = ({ lessonsCount, isTrial, schedule, paymentData, className, subscription, subscriptionNameValue, }) => {
    var _a;
    const { t } = useTranslation();
    const { name = "", price = 0 } = subscription || {};
    const scheduleData = useStudentCheckoutData();
    const trialLessonTime = (_a = scheduleData === null || scheduleData === void 0 ? void 0 : scheduleData.trialLesson[0]) === null || _a === void 0 ? void 0 : _a.time;
    const [startDate, setStartDate] = useState(dayjs(trialLessonTime));
    const [isAcquainted, setAcquainted] = useState(false);
    const isEvent = "eventId" in schedule;
    const isConcert = "concertId" in schedule;
    let subscriptionName = name;
    if (isTrial) {
        subscriptionName = t("student~Попробовать");
    }
    else if (isEvent) {
        subscriptionName = t("student~Event");
    }
    else if (isConcert) {
        subscriptionName = t("student~Концерт");
    }
    else if (lessonsCount <= 3) {
        subscriptionName = subscriptionNameValue || t("student~Разовое занятие");
    }
    else {
        subscriptionName = `${lessonsCount} ${getLessonDeclension(t, lessonsCount)}`;
    }
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: s.card },
            !isEvent && !isConcert && (React.createElement("div", { className: s.priceSection },
                React.createElement("div", { className: s.subscriptionName },
                    subscriptionName,
                    React.createElement(CheckoutStartDateInputContainer, { schedule: schedule, subscription: subscription, value: startDate, onChange: setStartDate })),
                React.createElement("div", { className: s.subscriptionPrice },
                    (paymentData === null || paymentData === void 0 ? void 0 : paymentData.amount) || price,
                    t("student~ грн")))),
            React.createElement("div", { className: s.bottomSection },
                React.createElement("div", { className: s.summarySection },
                    React.createElement("div", { className: s.summary }, t("student~Итого:")),
                    React.createElement("div", { className: s.summaryPrice },
                        (paymentData === null || paymentData === void 0 ? void 0 : paymentData.amount) || price,
                        t("student~ грн"))),
                React.createElement("form", { className: s.form, method: "POST", action: "https://www.liqpay.ua/api/3/checkout" },
                    Boolean(paymentData) && paymentDataToFormInputs(paymentData),
                    React.createElement(Button, { className: s.payButton, type: "submit", disabled: !isAcquainted || !paymentData }, t("student~Оплатить"))),
                React.createElement(Checkbox, { checked: isAcquainted, onCheck: () => setAcquainted(prev => !prev), className: s.acquainted },
                    React.createElement("div", { className: s.legalInfo },
                        t("student~Я ознайомлений(-а) з "),
                        React.createElement(Link, { to: publicContracts, target: "_blank" }, t("student~договором оферти")),
                        " ",
                        t("student~й "),
                        " ",
                        React.createElement(Link, { to: "/rules.pdf", target: "_blank" }, t("student~правилами"))))))));
};
